<template>
	<div>
		<b-modal
			id="clonetest"
			v-model="cloneTestModal"
			centered
			hide-footer
			hide-header
			@hide="$emit('hide')"
		>
			<div class="modalheading">Clone Test</div>
			<div @click="closeclonemodal()" class="xMarkCancel pointer">
				<img src="../../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<span class="caution-modal-text"
				>Are you sure you want to clone this test ?</span
			>

			<div class="clonetestname d-flex align-items-center">
				<span class="ml-1 caution-modal-text"> Current Test Name :</span>
				<span class="ml-1 caution-modal-text"> {{ clone.name }}</span>
			</div>
			<b-row>
				<b-col>
					<div class="topDiv mt-4">
						<label class="fieldsetStyle"
							>New Test Name &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							class="inputField"
							id="input-1"
							placeholder="Enter here"
							v-on:keyup.enter="cloneTest()"
							v-model="$v.clonedata.$model"
							type="text"
							:class="{ error: $v.clonedata.$error }"
							autofocus
						></b-form-input>
						<div
							class="clonetest-name-validation-icon"
							v-if="$v.clonedata.$dirty && !$v.clonedata.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="clonetest-name-validation-icon"
							v-if="!$v.clonedata.maxLength && $v.clonedata.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 128 characters',
							}"
							variant="primary"
						>
							<img src="../../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="clonetest-name-validation-icon"
							v-if="!$v.clonedata.alpha && $v.clonedata.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Please Enter a Valid Test Name',
							}"
						>
							<img src="../../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<div class="d-flex justify-content-end mt-4">
				<b-button class="addbtn">
					<span @click="cloneTest()"> Clone </span>
				</b-button>
			</div>
		</b-modal>
	</div>
</template>
<script>
import { postTest } from "../../../utils/apiFunctions.js";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
	props: {
		cloneTestModal: Boolean,
		clone: Object,
		topicID: String,
		context: Object,
	},
	data() {
		return {
			clonedata: null,
		};
	},
	validations: {
		clonedata: {
			required,
			maxLength: maxLength(128),
			alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
		},
	},
	computed: {
		...mapGetters("userVUEX", {
			leaderboardAdminAccess: "getleaderboardAdminAccess",
		}),
	},
	created() {},
	methods: {
		async cloneTest() {
			this.$v.clonedata.$touch();
			if (!this.$v.clonedata.$invalid) {
				try {
					let payload = {
						name: this.clonedata,
						topicID: this.topicID,
						portion: "Test",
						publicAvailability: false,
						duplication: this.clone.testID,
						categoryID: this.clone.categoryID,
						subCategoryID: this.clone.subCategoryID,
					};
					if (
						this.leaderboardAdminAccess &&
						(!("leaderboard" in payload) || !("leaderboardCategory" in payload))
					) {
						payload.leaderboard = this.clone.leaderboard;
						payload.leaderboardCategory = this.clone.leaderboardCategory;
					}

					const response = await postTest(payload);
					if (response.status === 200) {
						this.$emit("resetPagination");
						setTimeout(() => {
							this.context.successToast("Test cloned successfully!");
						}, 200);
						this.$bvModal.hide("clonetest");
					} else if (response.status === 409) {
						this.activetest = response.data.data.tests;
						this.$bvModal.show("testsamename");
					} else if (response.status == 208) {
						this.context.errorToast(`The test name already exists`);
					} else if (response.status == 404) {
						this.context.errorToast(response.data.data.Data);
						this.$bvModal.hide("clonetest");
					} else {
						this.context.errorToast("Something went wrong!");
						this.$bvModal.hide("clonetest");
					}
				} catch (error) {
					console.log(error);
				}
			}
		},
		closeclonemodal() {
			this.$v.$reset();
			this.$bvModal.hide("clonetest");
			this.$emit("card-close");
		},
	},
};
</script>
